<template>
  <div class="container mx-auto p-4">
    <div class="flex items-center justify-between">
      <h2 class="text-2xl font-bold mb-4">Assignments</h2>
      <button type="button" @click="addQuestion" class="hidden md:block px-4 py-2 bg-primary text-white rounded">Add Question</button>
    </div>

    <div>
      <form @submit.prevent="addAssignment" class="mt-4">
       
        <div class="mb-2">
          <label class="block font-bold mb-1 text-lg">Questions</label>
          <div v-for="(question, qIndex) in newAssignment.questions" :key="qIndex" class="mb-2">
            <input type="text" v-model="question.text" placeholder="Question" class="w-full border rounded p-2 mb-2" />
            <div v-for="(option, oIndex) in question.options" :key="oIndex">
              <input type="text" v-model="question.options[oIndex]" placeholder="Option" class="w-full border rounded p-2 mb-2" />
            </div>
            <div class="space-x-4">
              <button type="button" @click="removeQuestion(qIndex)" class="px-4 py-2 bg-red-500 text-white rounded">Remove Question</button>
              <button type="button" @click="addOption(question)" class="px-4 py-2 bg-primary text-white rounded">Add Option</button>
            </div>
          </div>
          <button type="button" @click="addQuestion" class="block md:hidden px-4 py-2 bg-primary text-white rounded">Add Question</button>
        </div>
        <button type="submit" class="px-4 py-2 bg-primary text-white rounded">Add Assignment</button>
      </form>
      <ul class="mt-10">
        <li v-for="(assignment, index) in assignments" :key="index" class="mb-2">
          <div class="border p-4">
            <h3 class="text-lg font-semibold">{{ assignment.title }}</h3>
            <p>{{ assignment.description }}</p>
            <ul>
              <li v-for="(question, qIndex) in assignment.questions" :key="qIndex">
                <h4 class="font-bold text-lg">Question: {{ question.text }}</h4>
                <ul>
                  <h4 class="font-bold text-md">Options</h4>
                  <li v-for="(option, oIndex) in question.options" :key="oIndex">{{ option }}</li>
                </ul>
              </li>
            </ul>
            <div class="space-x-4 mt-2">
              <button @click="editAssignment(index)" class="px-4 py-2 bg-yellow-500 text-white rounded">Edit</button>
              <button @click="deleteAssignment(index)" class="px-4 py-2 bg-red-500 text-white rounded">Delete</button>
            </div>
          </div>
        </li>
      </ul>

      <div v-if="editingIndex !== null" class="mt-10">
        <h3 class="text-2xl font-bold mb-4">Edit Assignment</h3>
        <form @submit.prevent="updateAssignment" class="mt-4">
          
          <div class="mb-2">
            <label class="block font-bold mb-1 text-lg">Questions</label>
            <div v-for="(question, qIndex) in editAssignmentData.questions" :key="qIndex" class="mb-2">
              <input type="text" v-model="question.text" placeholder="Question" class="w-full border rounded p-2 mb-2" />
              <div v-for="(option, oIndex) in question.options" :key="oIndex">
                <input type="text" v-model="question.options[oIndex]" placeholder="Option" class="w-full border rounded p-2 mb-2" />
              </div>
              <div class="space-x-4">
                <button type="button" @click="removeEditQuestion(qIndex)" class="px-4 py-2 bg-red-500 text-white rounded">Remove Question</button>
                <button type="button" @click="addEditOption(question)" class="px-4 py-2 bg-primary text-white rounded">Add Option</button>
              </div>
            </div>
            <button type="button" @click="addEditQuestion" class="block md:hidden px-4 py-2 bg-primary text-white rounded">Add Question</button>
          </div>
          <button type="submit" class="px-4 py-2 bg-primary text-white rounded">Update Assignment</button>
          <button type="button" @click="cancelEdit" class="px-4 py-2 bg-gray-500 text-white rounded">Cancel</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

const assignments = ref([]);
const editingIndex = ref(null);

const newAssignment = ref({
  title: '',
  description: '',
  questions: [{ text: '', options: [''] }],
});

const editAssignmentData = ref({
  title: '',
  description: '',
  questions: [{ text: '', options: [''] }],
});

const addAssignment = () => {
  assignments.value.push({
    title: newAssignment.value.title,
    description: newAssignment.value.description,
    questions: [...newAssignment.value.questions],
  });
  newAssignment.value.title = '';
  newAssignment.value.description = '';
  newAssignment.value.questions = [{ text: '', options: [''] }];
};

const addQuestion = () => {
  newAssignment.value.questions.push({ text: '', options: [''] });
};

const removeQuestion = (index) => {
  newAssignment.value.questions.splice(index, 1);
};

const addOption = (question) => {
  question.options.push('');
};

const editAssignment = (index) => {
  editingIndex.value = index;
  editAssignmentData.value = JSON.parse(JSON.stringify(assignments.value[index]));
};

const updateAssignment = () => {
  assignments.value[editingIndex.value] = editAssignmentData.value;
  cancelEdit();
};

const deleteAssignment = (index) => {
  assignments.value.splice(index, 1);
};

const cancelEdit = () => {
  editingIndex.value = null;
};

const addEditQuestion = () => {
  editAssignmentData.value.questions.push({ text: '', options: [''] });
};

const removeEditQuestion = (index) => {
  editAssignmentData.value.questions.splice(index, 1);
};

const addEditOption = (question) => {
  question.options.push('');
};
</script>

<style scoped>
/* Add Tailwind CSS styles here */
</style>
